export default {
  content: 'Strona internetowa korzysta z plików cookies w celach funkcjonalnych zgodnie z ',
  link: 'polityką prywatności',
  accept: 'akceptuję',
  accept_cookies: 'Akceptuję regulamin',
  cancel: 'Nie akceptuję',
};
